export default "__VITE_ASSET__fe586be8__"